export const BREAKPOINTS = {
  PHONE_MAX: 575.98,
  TABLET_MIN: 576,
  TABLET_MAX: 991.98,
  DESKTOP_MIN: 992,
}
